import { LOGIN, LOGOUT, CLEAR_ERRORS, GET_TOKEN, GET_USER, RESET_PASSWORD, FIRST_TIME_LOGIN, UPDATE_UNIT_TREE } from '../types'

const initialState = {
  accountId: null,
  assignedRole: null,
  assignedUnits: [],
  defaultPage: '',
  defaultView: '',
  defaultReport: '',
  error: false,
  firstTimeLogin: false,
  isAuthenticated: false,
  isSSO: false,
  message: null,
  passwordResetRequired: false,
  permissions: [],
  supervisorID: null,
  token: null,
  tokenExp: null,
  unitTree: [],
  unitSupervisorMap: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOGIN: return {
      ...state,
      ...action.payload,
      isAuthenticated: true
    }
    case LOGOUT: return {
      ...state,
      ...initialState,
      message: action.payload.message || null,
      error: action.payload.error || false,
      token: null
    }
    case GET_TOKEN: return {
      ...state,
      token: action.payload.token,
      tokenExp: action.payload.exp
    }
    case GET_USER: return {
      ...state,
      user: action.payload
    }
    case CLEAR_ERRORS: return {
      ...state,
      message: initialState.message,
      error: initialState.error
    }
    case RESET_PASSWORD: return {
      ...state,
      passwordResetRequired: false
    }
    case FIRST_TIME_LOGIN: return {
      ...state,
      firstTimeLogin: false
    }
    case UPDATE_UNIT_TREE: return {
      ...state,
      unitTree: action.payload
    }
    default: return state
  }
}
